import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {IBaseBlockComponent} from "../../../../interfaces";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-scene-block-youtube',
  templateUrl: './block-youtube.component.html',
  styleUrls: ['./block-youtube.component.scss']
})
export class BlockYoutubeComponent extends BlockBaseComponent implements IBaseBlockComponent {
  videoLists = [
    {
      optionsLabel: 'video id list',
      optionValue: 'manually',
      optionType: 'text'
    },
    {
      optionsLabel: 'most viewed',
      optionValue: 'most_viewed',
      optionType: 'text'
    },
    {
      optionsLabel: 'youtube category',
      optionValue: 'category',
      optionType: 'text'
    },
    {
      optionsLabel: 'youtube channel',
      optionValue: 'channel',
      optionType: 'text'
    }
  ];
  categories = [
    {
      optionsLabel: 'Gaming',
      optionValue: '20',
      optionType: 'text'
    },
    {
      optionsLabel: 'Film and Animation',
      optionValue: '2',
      optionType: 'text'
    },
    {
      optionsLabel: 'Entertainment',
      optionValue: '24',
      optionType: 'text'
    },
    {
      optionsLabel: 'How to and style',
      optionValue: '26',
      optionType: 'text'
    },
    {
      optionsLabel: 'Comedy',
      optionValue: '23',
      optionType: 'text'
    },
    {
      optionsLabel: 'Gaming',
      optionValue: '20',
      optionType: 'text'
    },
    {
      optionsLabel: 'Sports',
      optionValue: '17',
      optionType: 'text'
    },
    {
      optionsLabel: 'Pets and Animals',
      optionValue: '15',
      optionType: 'text'
    },
    {
      optionsLabel: 'Music',
      optionValue: '10',
      optionType: 'text'
    },
    {
      optionsLabel: 'Autos and Vehicles',
      optionValue: '1',
      optionType: 'text'
    },
    {
      optionsLabel: 'Science and Technology',
      optionValue: '28',
      optionType: 'text'
    }
  ];
  regions = [
    {
      optionsLabel: 'United States',
      optionValue: 'US',
      optionType: 'text'
    },
    {
      optionsLabel: 'Argentina',
      optionValue: 'AR',
      optionType: 'text'
    },
    {
      optionsLabel: 'Australia',
      optionValue: 'AU',
      optionType: 'text'
    }, {
      optionsLabel: 'Austria',
      optionValue: 'AT',
      optionType: 'text'
    }, {
      optionsLabel: 'Belgium',
      optionValue: 'BE',
      optionType: 'text'
    }, {
      optionsLabel: 'Brazil',
      optionValue: 'BR',
      optionType: 'text'
    }, {
      optionsLabel: 'Canada',
      optionValue: 'CA',
      optionType: 'text'
    }, {
      optionsLabel: 'Chile',
      optionValue: 'CL',
      optionType: 'text'
    }, {
      optionsLabel: 'Columbia',
      optionValue: 'CO',
      optionType: 'text'
    }, {
      optionsLabel: 'Cezk Republic',
      optionValue: 'CZ',
      optionType: 'text'
    }, {
      optionsLabel: 'Egypt',
      optionValue: 'EG',
      optionType: 'text'
    }, {
      optionsLabel: 'France',
      optionValue: 'FR',
      optionType: 'text'
    }, {
      optionsLabel: 'Germany',
      optionValue: 'DE',
      optionType: 'text'
    }, {
      optionsLabel: 'Great Britain',
      optionValue: 'GB',
      optionType: 'text'
    }, {
      optionsLabel: 'Hong Kong',
      optionValue: 'HK',
      optionType: 'text'
    }, {
      optionsLabel: 'Hungary',
      optionValue: 'HU',
      optionType: 'text'
    }, {
      optionsLabel: 'India',
      optionValue: 'IN',
      optionType: 'text'
    }, {
      optionsLabel: 'Ireland',
      optionValue: 'IE',
      optionType: 'text'
    }, {
      optionsLabel: 'Israel',
      optionValue: 'IL',
      optionType: 'text'
    }, {
      optionsLabel: 'Italy',
      optionValue: 'IT',
      optionType: 'text'
    }, {
      optionsLabel: 'Japan',
      optionValue: 'JP',
      optionType: 'text'
    }, {
      optionsLabel: 'Jordan',
      optionValue: 'JO',
      optionType: 'text'
    }, {
      optionsLabel: 'Malaysia',
      optionValue: 'MY',
      optionType: 'text'
    }, {
      optionsLabel: 'Mexico',
      optionValue: 'MX',
      optionType: 'text'
    }, {
      optionsLabel: 'Morocco',
      optionValue: 'MA',
      optionType: 'text'
    }, {
      optionsLabel: 'Netherlands',
      optionValue: 'NL',
      optionType: 'text'
    }, {
      optionsLabel: 'New Zealand',
      optionValue: 'NZ',
      optionType: 'text'
    }, {
      optionsLabel: 'Peru',
      optionValue: 'PE',
      optionType: 'text'
    }, {
      optionsLabel: 'Philippines',
      optionValue: 'PE',
      optionType: 'text'
    }, {
      optionsLabel: 'Poland',
      optionValue: 'PL',
      optionType: 'text'
    }, {
      optionsLabel: 'Russia',
      optionValue: 'RU',
      optionType: 'text'
    }, {
      optionsLabel: 'South Africa',
      optionValue: 'SA',
      optionType: 'text'
    }, {
      optionsLabel: 'Singapore',
      optionValue: 'SG',
      optionType: 'text'
    }, {
      optionsLabel: 'South Africa',
      optionValue: 'ZA',
      optionType: 'text'
    }, {
      optionsLabel: 'South Korea',
      optionValue: 'KR',
      optionType: 'text'
    }, {
      optionsLabel: 'Spain',
      optionValue: 'ES',
      optionType: 'text'
    }, {
      optionsLabel: 'Sweden',
      optionValue: 'SE',
      optionType: 'text'
    }, {
      optionsLabel: 'Switzerland',
      optionValue: 'CH',
      optionType: 'text'
    }, {
      optionsLabel: 'Taiwan',
      optionValue: 'TW',
      optionType: 'text'
    }, {
      optionsLabel: 'United Arab Emirates',
      optionValue: 'AE',
      optionType: 'text'
    }
  ];
  listType;

  constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, private toastr: ToastrService) {
    super(storeSelector, dialog);
  }

  override submit(formValues) {
    if (!formValues.VideoIdList) formValues.VideoIdList = '';
    if (!formValues.channel) formValues.channel = '';
    super.submit(formValues);
  }

  override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
    super.initApplyStoreToDynamic(applyStoreToDynamic);
  }

  override componentInit() {
    super.componentInit();
  }

  override componentStoreUpdates() {
    super.componentStoreUpdates();
    this.sceneItem.Data[0].YouTube[0].$.listType === 'manually' ? this.setUiConfigHide('listRegion', true) : this.setUiConfigHide('listRegion', false);
    this.sceneItem.Data[0].YouTube[0].$.listType === 'manually' ? this.setUiConfigHide('VideoIdList', false) : this.setUiConfigHide('VideoIdList', true);
    this.sceneItem.Data[0].YouTube[0].$.listType === 'channel' ? this.setUiConfigHide('channel', false) : this.setUiConfigHide('channel', true);
    this.sceneItem.Data[0].YouTube[0].$.listType === 'category' ? this.setUiConfigHide('category', false) : this.setUiConfigHide('category', true);
  }

  override initRegisterDynamic() {
    this.uiConfigInit = [
      {
        type: "input",
        value: '1',
        label: this.translocoService.translate('general.volume', {}, this.translocoService.getActiveLang()),
        inputType: "range",
        min: 0,
        max: 1,
        step: 0.1,
        name: "volume",
        storePath: 'Data[0].YouTube[0].$.volume'
      },
      {
        type: "select",
        label: this.translocoService.translate('general.quality', {}, this.translocoService.getActiveLang()),
        name: "quality",
        value: "quality",
        options: ["default", "small", "medium", "large", "hd720"],
        storePath: 'Data[0].YouTube[0].$.quality'
      },
      {
        type: "select",
        label: this.translocoService.translate('general.listType', {}, this.translocoService.getActiveLang()),
        name: "listType",
        value: "manually",
        options: this.videoLists,
        storePath: 'Data[0].YouTube[0].$.listType'
      },
      {
        type: "select",
        label: this.translocoService.translate('general.region', {}, this.translocoService.getActiveLang()),
        name: "listRegion",
        value: "",
        options: this.regions,
        ignoreMissingValue: true,
        storePath: 'Data[0].YouTube[0].$.listRegion'
      },
      {
        type: "select",
        label: this.translocoService.translate('general.category', {}, this.translocoService.getActiveLang()),
        name: "category",
        value: "",
        options: this.categories,
        ignoreMissingValue: true,
        storePath: 'Data[0].YouTube[0].$.category'
      },
      {
        type: "input",
        value: "",
        label: this.translocoService.translate('general.channel', {}, this.translocoService.getActiveLang()),
        inputType: "text",
        name: "channel",
        ignoreMissingValue: true,
        storePath: 'Data[0].YouTube[0].$.channel'
      },
      {
        type: "input",
        value: "",
        label: this.translocoService.translate('general.channel', {}, this.translocoService.getActiveLang()),
        inputType: "textarea",
        name: "VideoIdList",
        ignoreMissingValue: true,
        storePath: 'Data[0].YouTube[0].VideoIdList'
      },
      {
        type: "checkbox",
        value: '1',
        label: this.translocoService.translate('general.randomOrder', {}, this.translocoService.getActiveLang()),
        inputType: "text",
        name: "randomOrder",
        storePath: 'Data[0].YouTube[0].$.randomOrder'
      }
      // ,{
      //     type: "checkbox",
      //     value: '1',
      //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
      //     name: "gpu",
      //     storePath: '$.gpu'
      // }
    ];
  }
}
